import { createContext, useContext } from 'react';

export const ProjectsContext = createContext();

export const useProjectsContext = () => useContext(ProjectsContext);

export default ProjectsContext;
